import { Button } from '@kanda-libs/ks-design-library';

import ChangeToOpenBankingModal from './Modal';
import useChangeToOpenBankingButton from './useChangeToOpenBankingButton';

const ChangeToOpenBankingButton: React.FunctionComponent = function () {
  const { onClick } = useChangeToOpenBankingButton();
  return (
    <>
      <Button.Text
        id="card-change-to-ob"
        label="Pay with Open Banking!"
        icon="shield-check"
        className="mt-8 w-full"
        onClick={onClick}
      />
      <ChangeToOpenBankingModal />
    </>
  );
};

export default ChangeToOpenBankingButton;
